const FIXED_CLASS_ACTIVE = 'is-fixed';

class StickyLeftNavigation {
  constructor() {
    this.init();

    const callback = function (mutationsList) {
      for (let i = 0, len = mutationsList.length; i < len; i++) {
        if (mutationsList[i].type === 'childList') {
          this.init();
          break;
        }
      }
    }

    const observer = new MutationObserver(callback)
    const config = {
      childList: true,
      subtree: false,
    }
    var bodyEl = document.getElementById('main');
    if (!bodyEl) {
      bodyEl = document.getElementById('root');
    }
    observer.observe(bodyEl, config)
  }

  stickySidebar() {
    let self = this;
    let element = document.querySelector('.sidebar.sticky');
    if (!element) return;
    let position = window.pageYOffset + element.getBoundingClientRect().top;
    let parentEl = element.parentNode.parentNode;
    let parentWidth = parentEl.offsetWidth;
    element.style.width = `${parentWidth}px`;

    window.addEventListener('resize', () => {
      let parentEl = element.parentNode.parentNode;
      let parentWidth = parentEl.offsetWidth;
      element.style.width = `${parentWidth}px`;
    })

    window.addEventListener('scroll', () => {
      self.onScroll(position, element)
    })

    self.onScroll(position, element)
  }

  aboveScroll(position, element) {
    return position <= window.pageYOffset + 70
  }

  belowScroll(position, element) {
    let footer = document.querySelector('footer');
    let footerPosition = footer.getBoundingClientRect();
    console.log(position);
    return footerPosition.top + 100 <= (window.innerHeight || document.documentElement.clientHeight) 
  }

  onScroll(position, element) {
    if (this.aboveScroll(position) && !(this.belowScroll(position))) {
      this.setFixed(element, 'top')
    } else if (this.belowScroll()) {
      this.setFixed(element, 'bottom')
    } else {
      this.setStatic(element)
    }
  }

  setFixed(element, position) {
    element.classList.add(FIXED_CLASS_ACTIVE)
    if (position == 'top') {
      element.classList.remove('animated')
      element.style.position = 'fixed'
      element.style.top = '70px'
    } else {
      var footerPosition = document.querySelector('footer').getBoundingClientRect();
      element.style.top = 'unset'
      element.style.bottom = `${(window.innerHeight || document.documentElement.clientHeight) - footerPosition.y}px`
    }
  }

  setStatic(element) {
    element.classList.remove(FIXED_CLASS_ACTIVE)
    element.style.position = 'static'
    element.style.top = 'auto'
  }

  toggleMobileMenu() {
    var menu = this.nextElementSibling
    var targetMenuTitle = this

    targetMenuTitle.classList.toggle('is-open')

    menu.classList.toggle('is-collapsed')
    menu.classList.toggle('animateIn')
  }

  // Expand/Collapse sub menus
  listree() {
    const subMenuTriggerClass = 'listree-menu__trigger'
    const expandedClass = 'expanded'
    const collapsedClass = 'collapsed'
    const subMenuTrigger = document.getElementsByClassName(subMenuTriggerClass)

    Array.from(subMenuTrigger).forEach(function (trigger) {
      let subMenuHeading = trigger.parentNode
      subMenuHeading.classList.add(collapsedClass)

      if (subMenuHeading.nextElementSibling) {
        subMenuHeading.nextElementSibling.style.display = 'none'
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        let subMenuList = event.currentTarget.parentNode.nextElementSibling;
        var triggerParent = event.currentTarget.parentNode.parentNode;
        let expandedMenuItem = document.querySelector(`.${triggerParent.className} .listree-menu__item.expanded`);
        if (expandedMenuItem && !triggerParent.isEqualNode(expandedMenuItem.parentNode)) {
          var expandedMenuItemParent = expandedMenuItem.parentNode;
          if (triggerParent.classList[0] == expandedMenuItemParent.classList[0]) {
            expandedMenuItem.classList.remove(expandedClass);
            expandedMenuItem.nextElementSibling.style.display = 'none';
            let expandedItemChild = expandedMenuItem.nextElementSibling.querySelector('.expanded');
            if (expandedItemChild) {
              expandedItemChild.classList.remove(expandedClass);
              expandedItemChild.nextElementSibling.style.display = 'none';
            }
          }
        }

        if (subMenuList && subMenuList.style.display === 'none') {
          subMenuHeading.classList.remove(collapsedClass)
          subMenuHeading.classList.add(expandedClass)
          subMenuList.style.display = 'block';

          while (subMenuList && subMenuList.parentNode && subMenuList.parentNode.parentNode) {
            subMenuList = subMenuList.parentNode.parentNode;
            if (subMenuList.localName != 'ul') {
              break;
            }
            subMenuList.style.display = 'block';
          }

          let subMenuHeadingChild = subMenuHeading.nextElementSibling.querySelector('.expanded');
          if (subMenuHeadingChild) {
            subMenuHeadingChild.classList.remove(expandedClass);
            subMenuHeadingChild.nextElementSibling.style.display = 'none';
          }
        } else {
          subMenuHeading.classList.remove(expandedClass)
          subMenuHeading.classList.add(collapsedClass)
          subMenuList.style.display = 'none'
        }
        event.stopPropagation()
      })
    })
  }

  init() {
    let self = this
    console.log('Init sticky left navigation')

    // Init
    self.listree()
    self.stickySidebar()

    const active = document.querySelector('.listree-menu__item.active');
    if (active) {
      let previousLevel = active;
      if (active.nextElementSibling) {
        active.classList.remove('collapsed');
        active.classList.add('expanded');
        active.nextElementSibling.style.display = 'block';
        while (previousLevel.parentNode && previousLevel.parentNode.parentNode) {
          previousLevel = previousLevel.parentNode.parentNode;
          let previousLevelSibling = previousLevel.previousElementSibling;

          if (previousLevelSibling && previousLevelSibling.classList.contains('collapsed')) {
            previousLevelSibling.classList.remove('collapsed');
            previousLevelSibling.classList.add('expanded');
            previousLevel.style.display = 'block';
          }
        }


      } else {
        while (previousLevel.parentNode && previousLevel.parentNode.parentNode) {
          previousLevel = previousLevel.parentNode.parentNode;
          let previousLevelSibling = previousLevel.previousElementSibling;

          if (previousLevelSibling) {
            previousLevelSibling.classList.remove('collapsed');
            previousLevelSibling.classList.add('expanded');
            previousLevel.style.display = 'block';
            let previousPreviousLevel = previousLevelSibling.parentNode.parentNode;
            if (previousPreviousLevel.previousElementSibling) {
              previousPreviousLevel.previousElementSibling.classList.remove('collapsed');
              previousPreviousLevel.previousElementSibling.classList.add('expanded');
              previousPreviousLevel.style.display = 'block';
            }
          }
        }
      }
    }

    // Mobile
    //let toggleMobileMenuClass = document.querySelectorAll('.sticky__toggle');

    //for (var j = 0, jen = toggleMobileMenuClass.length; j < jen; j++) {
    //toggleMobileMenuClass[j].addEventListener('click', self.toggleMobileMenu)
    //}
  }
}

export default StickyLeftNavigation